import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../common/Loader";
import {
  getAllProfileDataByUser,
  getCustomerGeneralSettings,
  getGeneralSettingsData,
  getLoginUserDetails,
} from "../apiservice/ApiService";
import { getBrowserInfo, isTokenValid, isUserVerified } from "../utils/helper";
import CountrySelect from "../common/CountrySelect";
import { Checkbox } from "antd";

export const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [animation, setAnimation] = useState(true);
  const [userDetails, setUserDetails] = useState({
    email: "",
    password: "",
    country: undefined,
    migration: false,
  });
  const [loading, setLoading] = useState(false);
  const [checkHidden, setCheckHidden] = useState(false);
  const [token, setToken] = useState("");
  const [role, setRole] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(location.search);
  let adminToken = queryParameters.get("token");
  let tascRole = queryParameters.get("role");
  let id = queryParameters.get("id");
  let path = queryParameters.get("path");
  let boardId = queryParameters.get("board");
  let country = queryParameters.get("country");
  let region = queryParameters.get("region");
  let adminRegion = queryParameters.get("adminRegion");
  let redirect_url = queryParameters.get("redirect_url");

  const getRegionFromLanguage = () => {
    const language = navigator.language || navigator.userLanguage;
    if (language.includes("AE"))
      setUserDetails({ ...userDetails, country: "UAE" });
    else setUserDetails({ ...userDetails, country: "KSA" });
  };

  useEffect(() => {
    getRegionFromLanguage();
  }, []);

  const getProfileData = async () => {
    try {
      const response = await getAllProfileDataByUser();
      if (response.success) {
        localStorage.setItem("logo", response.data.response[0].file_location);
      }
      return response;
    } catch (err) {
    } finally {
    }
  };

  const checkTwoFactorAuthenticated = async (response, country) => {
    let browserInfo = getBrowserInfo();
    let verified = isUserVerified(
      localStorage.getItem("userId"),
      browserInfo.browser,
      browserInfo.os
    );
    if (response.role === "customer") {
      // if (verified) {
      await getProfileData();
      // if (sessionStorage.getItem("redirectUrl")) {
      //   setTimeout(() => {
      //     window.location.href = sessionStorage.getItem("redirectUrl");
      //     sessionStorage.removeItem("redirectUrl");
      //   }, 1000);
      // } else {
      //   setTimeout(() => {
      //     navigate("/user");
      //     sessionStorage.removeItem("redirectUrl");
      //   }, 1000);
      // }
      if (country === "UAE") {
        window.location.href = `https://onboardify.uae.tasc360.com/user?role=customer&token=${
          response.token
        }&country=${country}${
          redirect_url ? `&redirect_url=${redirect_url}` : ""
        }`;
      } else {
        window.location.href = `https://onboardify.ksa.tasc360.com/user?role=customer&token=${
          response.token
        }&country=${country}${
          redirect_url ? `&redirect_url=${redirect_url}` : ""
        }`;
      }
      // } else if (response["2fa_status"] == 1) {
      //   setTimeout(() => {
      //     navigate("/login/two-factor");
      //   }, 1000);
      // } else {
      //   await getProfileData();
      //   if (sessionStorage.getItem("redirectUrl")) {
      //     setTimeout(() => {
      //       window.location.href = sessionStorage.getItem("redirectUrl");
      //       sessionStorage.removeItem("redirectUrl");
      //     }, 1000);
      //   } else {
      //     setTimeout(() => {
      //       navigate("/user");
      //       sessionStorage.removeItem("redirectUrl");
      //     }, 1000);
      //   }
      // }
    } else {
      // if (sessionStorage.getItem("redirectUrl") !== null) {
      //   if (sessionStorage.getItem("redirectUrl").includes("signin")) {
      //     navigate("/admin");
      //     sessionStorage.removeItem("redirectUrl");
      //   } else {
      //     window.location.href = sessionStorage.getItem("redirectUrl");
      //     sessionStorage.removeItem("redirectUrl");
      //   }
      // }
      // navigate("/admin");
      if (adminRegion) {
        window.location.href = `https://onboardify.${
          adminRegion.toLowerCase() === "uae" ? "uae" : "ksa"
        }.tasc360.com/admin?role=admin&token=${response.token}&country=${
          adminRegion.toLowerCase() === "uae" ? "UAE" : "KSA"
        }`;
      } else if (country === "UAE") {
        window.location.href = `https://onboardify.uae.tasc360.com/admin?role=admin&token=${response.token}&country=${country}`;
      } else {
        window.location.href = `https://onboardify.ksa.tasc360.com/admin?role=admin&token=${response.token}&country=${country}`;
      }
    }
  };

  const loginAgain = async (url, country) => {
    console.log("url", url, country);
    let payload = JSON.stringify({
      email: userDetails.email,
      password: userDetails.password,
      domain: "onboardify",
      country_code: country,
    });

    try {
      const baseUrl = url;
      setLoading(true);
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Specify the content type
        },
        body: payload, // Convert payload to JSON string
      });

      if (!response.ok) {
        // Handle HTTP errors
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const newResponse = await response.json();

      if (newResponse.status && !newResponse.hasOwnProperty("status_code")) {
        toast.success("Logged In Successfull.");
        localStorage.setItem("token", newResponse.token);
        localStorage.setItem(
          "isTwoFactorEnabled",
          newResponse["2fa_status"] == 1 ? true : false
        );
        const response1 = await getLoginUserDetails(newResponse.token);
        if (response1.success) {
          localStorage.setItem("userEmail", response1.data.data.email);
          localStorage.setItem("userName", response1.data.data.name);
          localStorage.setItem("userId", response1.data.data.user_id);
          localStorage.setItem("phone", response1.data.data.phone);
        }
        checkTwoFactorAuthenticated(newResponse, country);
      } else {
        toast.error(newResponse.message);
      }
    } catch (err) {
      console.log(err, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    let payload = JSON.stringify({
      email: userDetails.email,
      password: userDetails.password,
      domain: "onboardify",
      country_code: userDetails.country === "UAE" ? "UAE" : "KSA",
    });

    try {
      const baseUrl = adminRegion
        ? `https://onboardifyapi.${adminRegion.toLowerCase()}.tasc360.com/commom-login`
        : userDetails.country === "UAE"
        ? "https://onboardifyapi.uae.tasc360.com/commom-login"
        : "https://onboardifyapi.ksa.tasc360.com/commom-login";
      setLoading(true);
      // const response = await loginApi(payload);
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Specify the content type
        },
        body: payload, // Convert payload to JSON string
      });

      if (!response.ok) {
        // Handle HTTP errors
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const newResponse = await response.json();
      // return;

      if (newResponse.status && !newResponse.hasOwnProperty("status_code")) {
        toast.success("Logged In Successfull.");
        localStorage.setItem("token", newResponse.token);
        localStorage.setItem(
          "isTwoFactorEnabled",
          newResponse["2fa_status"] == 1 ? true : false
        );
        const response1 = await getLoginUserDetails(newResponse.token);
        if (response1.success) {
          localStorage.setItem("userEmail", response1.data.data.email);
          localStorage.setItem("userName", response1.data.data.name);
          localStorage.setItem("userId", response1.data.data.user_id);
          localStorage.setItem("phone", response1.data.data.phone);
        }
        checkTwoFactorAuthenticated(newResponse, userDetails.country);
      } else if (
        !newResponse.status &&
        newResponse.hasOwnProperty("user_found") &&
        !newResponse.user_found
      ) {
        await loginAgain(
          `https://onboardifyapi.${
            userDetails.country.toLowerCase() == "uae" ? "ksa" : "uae"
          }.tasc360.com/commom-login`,
          userDetails.country.toLowerCase() == "uae" ? "KSA" : "UAE"
        );
      } else {
        toast.error(newResponse.message);
      }
    } catch (err) {
      console.log(err, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserDetails = (e, filter) => {
    setUserDetails({ ...userDetails, [filter]: e.target.value });
  };

  const checkEmailIsFilledAndValid = () => {
    const email = userDetails.email;
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,6}$/;
    if (email && emailRegex.test(email)) {
      return false;
    }
    return true;
  };

  const checkPasswordIsFilledValid = () => {
    const password = userDetails.password;
    if (password.length > 5) {
      return false;
    }
    return true;
  };

  const checkMigration = () => {
    if (checkHidden) {
      if (userDetails.migration) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setAnimation(false);
    }, 300);
  }, []);

  const handleNavigate = async () => {
    let browserInfo = getBrowserInfo();
    let verified = isUserVerified(
      localStorage.getItem("userId"),
      browserInfo.browser,
      browserInfo.os
    );
    let role = localStorage.getItem("role");
    if (role === "customer") {
      // if (verified) {
      const response1 = await getLoginUserDetails(
        localStorage.getItem("token")
      );
      if (response1.success) {
        localStorage.setItem("userEmail", response1.data.data.email);
        localStorage.setItem("userName", response1.data.data.name);
        localStorage.setItem("userId", response1.data.data.user_id);
        localStorage.setItem("phone", response1.data.data.phone);
      }
      navigate("/user");
      // }
      // else if (sessionStorage.getItem("isTwoFactorEnabled")) {
      //   setTimeout(() => {
      //     navigate("/login/two-factor");
      //   }, 1000);
      // } else {
      //   const response1 = await getLoginUserDetails(
      //     sessionStorage.getItem("token")
      //   );
      //   if (response1.success) {
      //     sessionStorage.setItem("userEmail", response1.data.data.email);
      //     sessionStorage.setItem("userName", response1.data.data.name);
      //     sessionStorage.setItem("userId", response1.data.data.user_id);
      //     sessionStorage.setItem("phone", response1.data.data.phone);
      //   }
      //   navigate("/user");
      // }
    }

    if (token && (role === "superAdmin" || role === "admin")) {
      const response1 = await getLoginUserDetails(
        localStorage.getItem("token")
      );
      if (response1.success) {
        localStorage.setItem("userEmail", response1.data.data.email);
        localStorage.setItem("userName", response1.data.data.name);
        localStorage.setItem("userId", response1.data.data.user_id);
      }
      navigate("/admin");
    }
  };

  const handleChangeCheckBoxMigration = (e) => {
    setUserDetails({ ...userDetails, migration: e.target.checked });
  };

  const adminLogin = async () => {
    let status = isTokenValid(adminToken);
    if (status.valid) {
      localStorage.setItem("token", adminToken);
      localStorage.setItem("role", tascRole);
      let res = await getLoginUserDetails(adminToken);

      if (res.success) {
        localStorage.setItem("userEmail", res.data.data.email);
        localStorage.setItem("userName", res.data.data.name);
        localStorage.setItem("userId", res.data.data.user_id);
      }

      if (tascRole === "customer") {
        if (id) {
          if (country.toUpperCase() === "UAE") {
            if (path) {
              window.location.href = `https://onboardify.uae.tasc360.com/user?role=customer&token=${adminToken}&country=${
                region ? region : country
              }&boardId=${boardId}&path=${path}&id=${id}`;
            } else {
              window.location.href = `https://onboardify.uae.tasc360.com/user?role=customer&token=${adminToken}&country=${
                region ? region : country
              }&boardId=${boardId}&id=${id}`;
            }
          } else {
            if (path) {
              window.location.href = `https://onboardify.ksa.tasc360.com/user?role=customer&token=${adminToken}&country=${
                region ? region : country
              }&boardId=${boardId}&path=${path}&id=${id}`;
            } else {
              window.location.href = `https://onboardify.ksa.tasc360.com/user?role=customer&token=${adminToken}&country=${
                region ? region : country
              }&boardId=${boardId}&id=${id}`;
            }
          }
        } else {
          const res2 = await getCustomerGeneralSettings(adminToken);
          if (res2.success) {
            localStorage.setItem("settings", res2.data.response.ui_settings);
            localStorage.setItem(
              "logo_location",
              res2.data.response.logo_location
            );
          }
          if (country === "UAE") {
            window.location.href = `https://onboardify.uae.tasc360.com/user?role=customer&token=${adminToken}&country=${
              region ? region : country
            }`;
          } else {
            window.location.href = `https://onboardify.ksa.tasc360.com/user?role=customer&token=${adminToken}&country=${
              region ? region : country
            }`;
          }
        }
      } else {
        const res = await getGeneralSettingsData();
        if (res?.success) {
          // console.log(response2)
          localStorage.setItem("settings", res?.data?.response.ui_settings);
          localStorage.setItem(
            "logo_location",
            res?.data?.response.logo_location
          );
        }
        if (country === "UAE") {
          window.location.href = `https://onboardify.uae.tasc360.com/admin?role=admin&token=${token}&country=${
            region ? region : country
          }`;
        } else {
          window.location.href = `https://onboardify.ksa.tasc360.com/admin?role=admin&token=${token}&country=${
            region ? region : country
          }`;
        }
      }
    } else {
      navigate("/signin");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (
        !checkEmailIsFilledAndValid() &&
        !checkPasswordIsFilledValid() &&
        userDetails.country != undefined
      ) {
        handleSubmit();
      }
    }
  };

  useEffect(() => {
    if (redirect_url && redirect_url.includes("uae")) {
      setUserDetails({ ...userDetails, country: "UAE" });
    } else if (redirect_url) {
      setUserDetails({ ...userDetails, country: "KSA" });
    } else if (region) {
      setUserDetails({ ...userDetails, country: region });
    }
  }, []);

  useEffect(() => {
    if (adminToken) {
      adminLogin();
    }
  }, [adminToken]);

  useEffect(() => {
    setTimeout(() => {
      setAnimation(false);
    }, 300);
  }, []);

  useEffect(() => {
    if (adminToken === null || adminToken === undefined) {
      handleNavigate();
    }
  }, []);

  // Trigger GTM event
  useEffect(() => {
    // Ensure dataLayer exists
    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];

      // Push event to dataLayer
      window.dataLayer.push({
        event: "Login Page Loaded",
        page: window.location.pathname,
      });
    }, 1000); // Delay by 1 second
  }, []);

  if (adminToken) {
    return <Loader />;
  }

  return (
    <div className="inc-auth-container">
      <div className="container auth-container text-center">
        {loading && <Loader />}
        <div className="cover-container w-100 h-100 pb-2 ">
          <div className="">
            <div className="animation-container" style={{ minHeight: "90px" }}>
              <div
                className={`header-heading1 ${
                  animation ? "animation-content" : ""
                } ff-ws `}
                style={{
                  transition: "transform 1s ease, opacity 2s ease",
                  fontSize: "50px",
                  fontWeight: "500",
                }}
              >
                Onboardify
              </div>
            </div>

            <div
              className="form-container mx-auto"
              style={{ maxWidth: "440px" }}
            >
              <div>
                <div>
                  <img
                    src="/newLogo.svg"
                    alt="TASC logo"
                    style={{ maxWidth: "220px" }}
                  />
                </div>
                <div
                  className="fs-24 ff-ws mb-2 text-inc-tundora fw-600"
                  style={{ color: "#434343" }}
                >
                  Sign In
                </div>
              </div>
              <div className="form-auth">
                <form className="form-auth" onKeyDown={handleKeyDown}>
                  <input
                    placeholder="Email"
                    type="email"
                    value={userDetails.email}
                    onChange={(e) => handleChangeUserDetails(e, "email")}
                    style={{ background: "#e8f0fe" }}
                    className="input-customer-focus form-control"
                  />
                  <div className="input-group flex-nowrap" id="password-filled">
                    <input
                      className="form-control input-customer-focus"
                      id="input-password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="password"
                      value={userDetails.password}
                      onChange={(e) => handleChangeUserDetails(e, "password")}
                      style={{ background: "#e8f0fe" }}
                    />
                    <span
                      className="input-group-text fs-5 encrypted eye-icon-container"
                      style={{
                        cursor: "pointer",
                        borderRadius: "0 50px 50px 0px",
                      }}
                    >
                      {showPassword ? (
                        <i
                          className="bi bi-eye-fill"
                          onClick={() => setShowPassword(false)}
                        ></i>
                      ) : (
                        <i
                          className="bi bi-eye-slash-fill"
                          onClick={() => setShowPassword(true)}
                        ></i>
                      )}
                    </span>
                  </div>
                  {/* <CountrySelect
                    formData={userDetails}
                    setFormData={setUserDetails}
                    redirect_url={redirect_url}
                    region={region}
                  /> */}

                  {checkHidden && (
                    <div className="d-flex" style={{ gap: "5px" }}>
                      <div>
                        <Checkbox
                          onChange={handleChangeCheckBoxMigration}
                        ></Checkbox>
                      </div>
                      <span style={{ color: "#212529A6", textAlign: "left" }}>
                        By switching regions, data from your current region will
                        be hidden until you switch back. You can create and
                        track new requests in the new region.
                      </span>
                    </div>
                  )}
                  <button
                    id="login-button"
                    className="btn btn-newgradiant btn-to-link btn-secondary mt-4 d-flex align-items-center"
                    type="button"
                    style={{
                      border: "0",
                      borderRadius: "50px",
                      gap: "10px",
                      padding: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "0.5s",
                      height: "46px",
                      opacity:
                        checkEmailIsFilledAndValid() ||
                        checkPasswordIsFilledValid() ||
                        checkMigration() ||
                        userDetails.country === undefined
                          ? "0.65"
                          : "",
                    }}
                    onClick={handleSubmit}
                    disabled={
                      checkEmailIsFilledAndValid() ||
                      checkPasswordIsFilledValid() ||
                      checkMigration() ||
                      userDetails.country === undefined
                    }
                  >
                    <span
                      style={{
                        fontFamily: "Montserrat!important",
                        fontSize: "12px",
                        fontWeight: 700,
                      }}
                    >
                      Sign In
                    </span>
                    <span
                      className="icon-btn_track"
                      style={{ marginLeft: "10px" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                      </svg>
                    </span>
                  </button>

                  <div className="d-flex justify-content-between align-items-start w-100 mt-2">
                    <a
                      href="/forgot"
                      className="fs-13"
                      style={{ color: "#434343" }}
                    >
                      Forgot Password?
                    </a>
                    <a
                      href="/register"
                      className="fs-13"
                      style={{ color: "#434343" }}
                    >
                      Create New Account?
                    </a>
                  </div>
                  <div
                    className="mt-3 fs-13 ff-ws text-inc-tundora"
                    style={{ color: "grey" }}
                  >
                    <span
                      className="mt-3 fs-13 ff-ws text-inc-tundora"
                      style={{ margin: "3px 0px" }}
                    >
                      {" "}
                      Powered by TASC Outsourcing®
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
};
